import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserTableControls from "./components/UserTableControls";
import UserNameLink from "./components/UserNameLink";
import { useUserTable, userSorters, userSortOptions } from "./hooks/useUserTable";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview } from "react-icons/gr";
import UserCard from "../../../componant/UserCard/UserCard";

const filterUsersByDuration = (users, filterType) => {
  const now = dayjs();

  return users.filter((user) => {
    const createdDate = dayjs(user?.createdOn);
    if (!createdDate.isValid()) return false;

    if (filterType === "today") {
      return createdDate.isSame(now, "day");
    }

    if (filterType === "weekly") {
      const weekStart = now.subtract(6, "day").startOf("day");

      return createdDate.valueOf() >= weekStart.valueOf();
    }

    if (filterType === "monthly") {
      return createdDate.isSame(now, "month");
    }

    return true;
  });
};

const getUniqueUsers = (users) => {
  const seen = new Set();

  return users.filter((user) => {
    const key = user?._id || user?.email || user?.mobile;
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

function DemoUser() {
  const [newID, setNewID] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef();
  const [data, setData] = useState({
    todayUsers: [],
    weeklyUsers: [],
    monthlyUsers: [],
  });

  const [filterType, setFilterType] = useState("today"); // today | weekly | monthly
  const [searchText, setSearchText] = useState("");
  const [dataType, setDataType] = useState("course"); // "course" | "contest"
  const [contests, setContests] = useState([]);
 const [allUsers, setAllUsers] = useState([]);
const [allUserTotal, setAllUserTotal] = useState(0);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
//   const [page, setPage] = useState(1);
// const pageSize = 10;



useEffect(() => {
  async function fetchData() {
    try {
      let response;

      if (filterType === "all") {
       if (dataType === "course") {
  const res = await axios.get("getPaidUsers");

  setAllUsers(res.data.result.users || []);
} 
       if (dataType === "contest") {
  const res = await axios.get("getAllContestUsers");

const users = res.data.result.map((item) => ({
  ...item.user,
  contest: item.contest,
  contestAmount: item.entryCoin,
  createdOn: item.createdOn,
}));
console.log(users,"users")
setAllUsers(users);
}

        return;
      }

      const api =
        dataType === "course"
          ? "userCourseStats"
          : "userContestStates";

      response = await axios.get(`${api}?type=${filterType}`);

      if (response?.data) {
        const result = response.data.result;

        setData(
          Array.isArray(result)
            ? { todayUsers: result }
            : result
        );
      }
    } catch (err) {
      console.log(err,"errrrrrrrrrrrrr")
      errorToast("Failed to fetch data");
    }
  }

  fetchData();
}, [dataType, filterType]); // 👈 add this

useEffect(() => {
  if (dataType !== "contest" || contests.length > 0) return;

  axios
    .get(`getAllContestForAdmin?type=${filterType}`)
    .then((response) => {
      const result = response?.data?.result;
      const contestList = Array.isArray(result)
        ? result
        : result?.contests || [];

      setContests(contestList);
    })
    .catch(() => {
      errorToast("Failed to fetch contests");
    });
}, [contests.length, dataType]);

const finalData = useMemo(() => {
  let users = [];

  if (filterType === "all") {
    users = Array.isArray(allUsers) ? allUsers : [];
  } else if (filterType === "today") {
    users = data.todayUsers || [];
  } else if (filterType === "weekly") {
    users = data.weeklyUsers || [];
  } else if (filterType === "monthly") {
    users = data.monthlyUsers || [];
  }


  return users;
}, [filterType, data, allUsers, fromDate, toDate]);

const filteredData = useMemo(() => {
  let users = [...finalData];

  if (fromDate) {
    const start = dayjs(fromDate).startOf("day").valueOf();

    users = users.filter(
      (u) => dayjs(u.createdOn).valueOf() >= start
    );
  }

  if (toDate) {
    const end = dayjs(toDate).endOf("day").valueOf();

    users = users.filter(
      (u) => dayjs(u.createdOn).valueOf() <= end
    );
  }

  return users;
}, [finalData, fromDate, toDate]);

  const table = useUserTable({
    data: filteredData,
    searchFields: ["name", "email", "mobile"],
    sorters: userSorters,
    pageSize: 10,
  });
  // total earning card
  const contestEntryCoinMap = useMemo(() => {
    return new Map(
      contests.map((contest) => [
        String(contest._id),
        Number(contest.entryCoin) || 0,
      ]),
    );
  }, [contests]);

  const totalEarning = useMemo(() => {
    if (dataType === "contest") {
      return table.processedData.reduce((total, user) => {
        const userContestTotal = (user?.contestAmount || [])
          return total + Number(user?.contestAmount || 0);
      }, 0);
    }

    return table.processedData.reduce((sum, user) => {
      return sum + (user?.amount || 0);
    }, 0);
  }, [contestEntryCoinMap, dataType, table.processedData]);

  
//   const paginatedData = useMemo(() => {
//   const start = (page - 1) * pageSize;
//   return table.processedData.slice(start, start + pageSize);
// }, [table.processedData, page]);

  // useEffect(() => {
  //   setPage(1);
  // }, [filterType]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "srNo",
        Cell: ({ value, row: { index } }) => <Cell text={index + 1} />,
      },
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?._id}
              name={value}
              planName={original?.planName}
              email={original?.email}
            />
            <div className="flex items-center justify-center gap-2 text-13 mt-2">
              <div className="flex gap-2 ">
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-green">
                    {original?.quizStats?.totalRight}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-red">
                    {original?.quizStats?.totalWrong}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-yellow-500">
                    {original?.quizStats?.totalSkipped}
                  </h1>
                </div>
              </div>
              {/* <div className="py-1 shadow-md px-2 bg-bgWhite text-black border-1 border-coolGray rounded-lg flex flex-col-2 gap-2 items-center justify-items-center">
                <Image
                  alt="Rate"
                  src={rateIcon}
                  width={20}
                  height={20}
                  layout="fixed"
                />

                <div className="text-center">
                  {original?.planName === "Silver"
                    ? 3000
                    : original?.planName === "Silver Plus"
                    ? 2000
                    : original?.planName === "Gold"
                    ? 1500
                    : original?.planName === "Platinum"
                    ? 1000
                    : 3000}
                  /1$
                </div>
              </div> */}
            </div>
          </>
        ),
      },

      {
        Header: "Mobile No.",
        accessor: "mobile",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={original.mobile} />
          </>
        ),
      },
      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },
   {
  Header: "Contest Earning (Rs)",
  accessor: "unifiedWallet.contestBalance",
  Cell: ({ row: { original } }) => (
    <Cell text={`Rs. ${Math.ceil(original?.unifiedWallet?.contestBalance || 0)}`} />
  ),
},
 {
  Header: "Total Contest Joined",
  accessor: "joinedContests",
  Cell: ({ row: { original } }) => (
    <Cell
      text={
        Array.isArray(original?.joinedContests)
          ? original.joinedContests.length
          : 0
      }
    />
  ),
},

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
                <MenuButton
                  as={Button}
                  className="bg-purple "
                  colorScheme="bgBlue"
                  onClick={() => setNewID(original._id)}
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <Link to={`/dash/view-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <GrOverview className="mr-4" /> View Details
                    </MenuItem>
                  </Link>
                  <Link to={`/dash/edit-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <MdEdit className="mr-4" /> Edit
                    </MenuItem>
                  </Link>

                  <MenuItem onClick={onOpen2}>
                    {" "}
                    <HiStatusOnline className="mr-4" /> Hold User
                  </MenuItem>

                  {/* <MenuItem onClick={onOpen}>
                    {" "}
                    <MdDelete className="mr-4" />
                    Delete
                  </MenuItem> */}
                  <Link to={`/dash/view-question/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> Change Plan
                    </MenuItem>
                  </Link>
                </MenuList>
              </Menu>
            </>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  );


  return (
    <div
      className="lg:py-8 py-4 bg-bgWhite"
      // style={{
      //   backgroundImage: `url('${bgImage}')`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center",
      // }}
    >
      <section class=" md:p-1 ">
        <div class="py-4 ">
          <h2 className="text-xl font-bold mb-4 text-purple text-oswald">
            {dataType === "course" ? "Course Users" : "Contest Users"}
          </h2>
         <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">


  {/* Filter Buttons */}
  <div className="flex flex-wrap gap-2 w-full lg:w-auto">

<Button
  onClick={() => setFilterType("all")}
  colorScheme={filterType === "all" ? "blue" : "gray"}
>
  All
</Button>
    <Button
  onClick={() => setFilterType("today")}
  colorScheme={filterType === "today" ? "blue" : "gray"}
>
  Today
</Button>

<Button
  onClick={() => setFilterType("weekly")}
  colorScheme={filterType === "weekly" ? "blue" : "gray"}
>
  Weekly
</Button>

<Button
  onClick={() => setFilterType("monthly")}
  colorScheme={filterType === "monthly" ? "blue" : "gray"}
>
  Monthly
</Button>
<div className="flex flex-wrap gap-3 items-center mt-3">
  <div>
    <label className="text-sm font-medium">From</label>
    <Input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div>
    <label className="text-sm font-medium">To</label>
    <Input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

  <Button
    colorScheme="red"
    onClick={() => {
      setFromDate("");
      setToDate("");
    }}
  >
    Clear
  </Button>
</div>

  </div>

  {/* Total Earning Card */}
  <div className="bg-green-100 text-green-700 px-4 py-3 rounded-lg shadow w-full lg:w-auto text-center">


    <h2 className="text-sm font-medium">
      {filterType === "all" && "Total Contest Entry Credits"}
      {filterType === "today" && "Today's contest Entry Credits"}
      {filterType === "weekly" && "Weekly contest Entry Credits"}
      {filterType === "monthly" && "Monthly contest Entry Credits"}
    </h2>


    <p className="text-xl font-bold">
      ₹ {totalEarning.toLocaleString()}
    </p>


  </div>

  {/* Search + Toggle */}
  <div className="w-full lg:w-auto">

    <UserTableControls
      search={table.search}
      onSearchChange={table.setSearch}
      sortOptions={userSortOptions}
      onSortChange={table.setSortBy}
    >


      <div className="flex bg-gray-100 rounded-lg p-1 w-full lg:w-fit">


        <Button
          size="sm"
          className="flex-1"
          onClick={() => setDataType("course")}
          variant={dataType === "course" ? "solid" : "ghost"}
          colorScheme={
            dataType === "course" ? "purple" : "gray"
          }
        >
          Course
        </Button>



        <Button
          size="sm"
          className="flex-1"
          onClick={() => setDataType("contest")}
          variant={dataType === "contest" ? "solid" : "ghost"}
          colorScheme={
            dataType === "contest" ? "purple" : "gray"
          }
        >
          Contest
        </Button>


      </div>


    </UserTableControls>


  </div>


</div>
          <div className="mt-2">
           {/* Desktop Table */}
<div className="mt-2 hidden md:block">
  <Table
    data={table.paginatedData || []}
    columns={columns}
    total={table.total}
    pageSize={table.pageSize}
    currentPage={table.page}
    onPageChange={table.setPage}
  />
</div>


{/* Mobile Card View */}
<div className="mt-4 block md:hidden space-y-4">
  {table.paginatedData.map((user) => (
    <UserCard
      key={user._id}
      user={user}
    />
  ))}
</div>
<div className="mt-4 flex justify-center items-center gap-3 md:hidden">
  <Button
    size="sm"
    isDisabled={table.page === 1}
    onClick={() => table.setPage(table.page - 1)}
  >
    Previous
  </Button>

  <span>
    {table.page} / {Math.ceil(table.total / table.pageSize)}
  </span>

  <Button
    size="sm"
    isDisabled={table.page >= Math.ceil(table.total / table.pageSize)}
    onClick={() => table.setPage(table.page + 1)}
  >
    Next
  </Button>
</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DemoUser;
